import React from 'react';

import { useJiraContext } from 'src/services/jira';

const JiraSideAdminLink = ({ children }) => {
  const { context: { browseBaseUrl } = {} } = useJiraContext();
  return <a href={`${browseBaseUrl}/plugins/servlet/pagerduty/admin`} target="_blank" rel="noopener noreferrer">{children}</a>;
};

export default JiraSideAdminLink;
